import { useQuery } from '@tanstack/react-query';

import { api, queryKeys } from '@/shared/api';

export interface Readiness {
  status: 'ok' | 'unavailable';
  checks: Record<string, 'ok' | 'error'>;
}

export function useReadiness() {
  return useQuery({
    queryKey: queryKeys.system.readiness,
    queryFn: ({ signal }) => api.get<Readiness>('/health/ready', { signal }),
    refetchInterval: 60_000,
  });
}
